// src/App.jsx - インポート修正版
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { UserProvider } from './contexts/UserContext';
import Login from './pages/Login';
import TrizDashboard from './contexts/nobishiro-dashboard/TrizDashboard';
import SubscriptionManager from './pages/SubscriptionManager';
import NobishiroDiagnosis from './pages/NobishiroDiagnosis';
import GrowthPatternDiagnosis from './pages/GrowthPatternDiagnosis';
import WallDiagnosis from './pages/WallDiagnosis';
import GoalSettingPage from './pages/GoalSettingPage';
import PersonalizedRoadmap from './components/dashboard/PersonalizedRoadmap';
import ProtectedRoute from './components/ProtectedRoute';
import AdminPage from './pages/AdminPage';
import ErrorBoundary from './components/ErrorBoundary';
import PaymentComplete from './pages/PaymentComplete';
import LearningLogPage from './pages/LearningLogPage';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import GuidePage from './pages/GuidePage';
import ReferralPage from './pages/ReferralPage';
import FrameworkDetailsPage from './pages/FrameworkDetailsPage';
import TeamDashboard from './pages/team/TeamDashboard';

// ★ 修正: .jsx拡張子を明記
import PaymentForm from './pages/PaymentForm.jsx';
import InviteAcceptPage from './pages/InviteAcceptPage.jsx';
import BreakthroughPage from './pages/BreakthroughPage';

// ページトラッキング
import usePageTracking from './hooks/usePageTracking';

// トラッキング付きアプリコンポーネント
const TrackedApp = () => {
  // ページトラッキング
  usePageTracking();

  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        {/* 認証不要ページ */}
        <Route path="/login" element={<Login />} />
        <Route path="/invite/:token" element={<InviteAcceptPage />} />

        {/* ホーム */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Navigate to="/dashboard" replace />
            </ProtectedRoute>
          }
        />

        {/* メインダッシュボード */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <TrizDashboard />
            </ProtectedRoute>
          }
        />

        {/* ★ プロライン統合：専用決済ページ */}
        <Route
          path="/payment"
          element={
            <ProtectedRoute>
              <PaymentForm />
            </ProtectedRoute>
          }
        />

        {/* サブスクリプション管理（プロライン統合版） */}
        <Route
          path="/subscription"
          element={
            <ProtectedRoute>
              <TrizDashboard>
                <SubscriptionManager />
              </TrizDashboard>
            </ProtectedRoute>
          }
        />

        {/* 決済完了ページ */}
        <Route path="/payment-complete" element={<PaymentComplete />} />
        <Route path="/learning-log" element={<ProtectedRoute><LearningLogPage /></ProtectedRoute>} />
        <Route path="/breakthrough" element={<ProtectedRoute><BreakthroughPage /></ProtectedRoute>} />

        {/* 利用規約・プライバシーポリシー */}
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/guide" element={<GuidePage />} />
        <Route path="/referral" element={<ProtectedRoute><ReferralPage /></ProtectedRoute>} />

        {/* 診断系ページ */}
        <Route
          path="/diagnosis"
          element={
            <ProtectedRoute>
              <TrizDashboard>
                <NobishiroDiagnosis />
              </TrizDashboard>
            </ProtectedRoute>
          }
        />

        <Route
          path="/growth-pattern-diagnosis"
          element={
            <ProtectedRoute>
              <TrizDashboard>
                <GrowthPatternDiagnosis />
              </TrizDashboard>
            </ProtectedRoute>
          }
        />

        <Route
          path="/wall-diagnosis"
          element={
            <ProtectedRoute>
              <TrizDashboard>
                <WallDiagnosis />
              </TrizDashboard>
            </ProtectedRoute>
          }
        />

        {/* ゴール設定・ロードマップ */}
        <Route
          path="/goal-setting"
          element={
            <ProtectedRoute>
              <TrizDashboard>
                <GoalSettingPage />
              </TrizDashboard>
            </ProtectedRoute>
          }
        />

        <Route
          path="/personal-roadmap"
          element={
            <ProtectedRoute>
              <TrizDashboard>
                <PersonalizedRoadmap />
              </TrizDashboard>
            </ProtectedRoute>
          }
        />

        {/* チームダッシュボード */}
        <Route
          path="/team"
          element={
            <ProtectedRoute>
              <TrizDashboard>
                <TeamDashboard />
              </TrizDashboard>
            </ProtectedRoute>
          }
        />

        {/* フレームワーク詳細 */}
        <Route
          path="/framework-details"
          element={
            <ProtectedRoute>
              <TrizDashboard>
                <FrameworkDetailsPage />
              </TrizDashboard>
            </ProtectedRoute>
          }
        />

        {/* 404ページ */}
        <Route
          path="*"
          element={
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
              <div className="text-center">
                <h1 className="text-4xl font-bold text-gray-900 mb-4">404 Not Found</h1>
                <p className="text-gray-600 mb-6">お探しのページが見つかりません</p>
                <a
                  href="/dashboard"
                  className="bg-indigo-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-indigo-700 transition-colors"
                >
                  ダッシュボードに戻る
                </a>
              </div>
            </div>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
};

// メインAppコンポーネント
function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <UserProvider>
          <Router>
            <TrackedApp />
          </Router>
        </UserProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;